import { DocumentPageImagesResult } from '@/lib/blocks/hooks/useDocumentPageImages';
import { generateDocumentTitle } from './generate-document-title';

import { TDocument } from '@ballerine/common';

type DocumentPage = {
  type?: string;
  fileName?: string;
  metadata?: { side?: string };
  ballerineFileId?: string;
  uri?: string;
  provider?: string;
};

export const pageImageUrlFallback = (page: DocumentPage | undefined) => {
  const uri = page?.uri;
  if (!uri || typeof uri !== 'string') {
    return undefined;
  }

  if (
    uri.startsWith('data:') ||
    uri.startsWith('blob:') ||
    uri.startsWith('http://') ||
    uri.startsWith('https://')
  ) {
    return uri;
  }

  const looksLikeBase64 =
    page?.provider === 'base64' ||
    uri.startsWith('/9j/') ||
    uri.startsWith('iVBOR') ||
    uri.startsWith('JVBERi0');

  if (!looksLikeBase64) {
    return undefined;
  }

  const mime =
    page?.type === 'png' || page?.type === 'image/png'
      ? 'image/png'
      : page?.type === 'pdf' || page?.type === 'application/pdf'
        ? 'application/pdf'
        : 'image/jpeg';

  return `data:${mime};base64,${uri}`;
};

export const getDocumentDetailsFromDocumentPage = ({
  document,
  documentIndex,
  documentPagesResults,
}: {
  document: TDocument;
  documentIndex: number;
  documentPagesResults: DocumentPageImagesResult;
}) => {
  return (
    document?.pages?.map((page: DocumentPage, pageIndex: number) => {
      const { type, fileName, metadata, ballerineFileId } = page;
      const title = generateDocumentTitle({
        category: document?.category ?? '',
        type: document?.type ?? '',
        variant: metadata?.side,
      });

      return {
        id: ballerineFileId,
        title,
        fileType: type,
        fileName,
        imageUrl: documentPagesResults?.[documentIndex]?.[pageIndex] || pageImageUrlFallback(page),
      };
    }) ?? []
  );
};
